import "./scss/product.scss";
import "./js/components/product-variant";
import "./js/components/slider-product";
import { productJS } from "./js/pages/product";
productJS();